import React, { useState } from "react";

import { Container, Row, Col } from "react-bootstrap";
import { MDBDataTableV5 } from "mdbreact";
import CustomGreenButton from "../../../../components/shared/custom-green-button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Skeleton from "@material-ui/lab/Skeleton";
import TableColumnDropdown from "../../../../components/shared/table-column-dropdown/table-column-dropdown";

import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import MenuBookIcon from "@material-ui/icons/MenuBook";
import swal from "sweetalert";

import { GENERAL_URL_API } from "../../../../shared/urls";
import { columnasRecomendacionPaquetes } from "../../../../shared/data/columnas";
import exportFromJSON from "export-from-json";

import RecomendacionFiltro from "./recomendacion-filtro";

const API_ENDPOINT = `${GENERAL_URL_API}/verDatos/recomendacionPaquetes.php`;

const RecomendacionPaquetes = () => {
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentFilters, setCurrentFilters] = useState(null);
  const [resumen, setResumen] = useState(null);

  const changeColumnStatus = (columnField) => {
    const temp = [...columns];
    const index = temp.findIndex((column) => column.field === columnField);
    temp[index].isVisible = !temp[index].isVisible;
    setColumns(temp);
  };

  const buildFormData = (descargar = false) => {
    const fd = new FormData();
    fd.append("superInstituto", currentFilters?.superInstituto || "");
    fd.append("nombre", currentFilters?.nombre || "");
    fd.append("cantidad", currentFilters?.cantidad || 0);
    fd.append("pctCliente", currentFilters?.pctCliente ?? 0);
    fd.append("pctGlobal", currentFilters?.pctGlobal ?? 0);
    fd.append("pctNovedades", currentFilters?.pctNovedades ?? 0);
    if (currentFilters?.fechaInicioCliente) {
      fd.append("fechaInicioCliente", currentFilters.fechaInicioCliente);
    }
    if (currentFilters?.fechaFinCliente) {
      fd.append("fechaFinCliente", currentFilters.fechaFinCliente);
    }
    if (currentFilters?.fechaInicioGlobal) {
      fd.append("fechaInicioGlobal", currentFilters.fechaInicioGlobal);
    }
    if (currentFilters?.fechaFinGlobal) {
      fd.append("fechaFinGlobal", currentFilters.fechaFinGlobal);
    }
    if (currentFilters?.fechaDesdeNovedades) {
      fd.append("fechaDesdeNovedades", currentFilters.fechaDesdeNovedades);
    }
    if (descargar) fd.append("descargar", 1);
    return fd;
  };

  const handleGenerar = async (filtros) => {
    setLoading(true);
    setCurrentFilters(filtros);

    const fd = new FormData();
    fd.append("superInstituto", filtros.superInstituto);
    fd.append("nombre", filtros.nombre);
    fd.append("cantidad", filtros.cantidad);
    fd.append("pctCliente", filtros.pctCliente);
    fd.append("pctGlobal", filtros.pctGlobal);
    fd.append("pctNovedades", filtros.pctNovedades);
    if (filtros.fechaInicioCliente) fd.append("fechaInicioCliente", filtros.fechaInicioCliente);
    if (filtros.fechaFinCliente) fd.append("fechaFinCliente", filtros.fechaFinCliente);
    if (filtros.fechaInicioGlobal) fd.append("fechaInicioGlobal", filtros.fechaInicioGlobal);
    if (filtros.fechaFinGlobal) fd.append("fechaFinGlobal", filtros.fechaFinGlobal);
    if (filtros.fechaDesdeNovedades) fd.append("fechaDesdeNovedades", filtros.fechaDesdeNovedades);

    try {
      const res = await fetch(API_ENDPOINT, {
        method: "POST",
        credentials: "include",
        body: fd,
      });
      const resJSON = await res.json();

      if (resJSON.status !== 1) {
        await swal({
          title: "Error",
          text: resJSON.info || "No se pudo generar la preselección",
          icon: "error",
        });
        setRows([]);
        setColumns([]);
        setResumen(null);
        setLoading(false);
        return;
      }

      if (resJSON.info?.includes("No hay resultados")) {
        await swal({ title: "Error", text: "No se encontraron libros para recomendar", icon: "error" });
      }

      const tempColumns = columnasRecomendacionPaquetes.map((col) => ({ ...col, isVisible: true }));
      setRows(resJSON.data || []);
      setColumns(tempColumns);
      setResumen(resJSON.resumen || null);
    } catch (e) {
      await swal({
        title: "Error",
        text: e.message || "No se pudo generar la preselección",
        icon: "error",
      });
      setRows([]);
      setColumns([]);
      setResumen(null);
    }
    setLoading(false);
  };

  const downloadExcelFromApi = async () => {
    const res = await fetch(API_ENDPOINT, {
      method: "POST",
      credentials: "include",
      body: buildFormData(true),
    });

    const contentType = res.headers.get("content-type") || "";
    if (!res.ok) {
      const errJson = contentType.includes("application/json") ? await res.json() : null;
      throw new Error(errJson?.info || `Error ${res.status}`);
    }
    if (contentType.includes("application/json")) {
      const err = await res.json();
      throw new Error(err?.info || "No se pudo generar el archivo");
    }

    const blob = await res.blob();
    let filename = `preseleccion-${new Date().toISOString().split("T")[0]}.xlsx`;
    const disposition = res.headers.get("content-disposition") || "";
    const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
    const extracted = match ? match[1] || match[2] : null;
    if (extracted) {
      try {
        filename = decodeURIComponent(extracted);
      } catch (_) {
        filename = extracted;
      }
    }

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleCsvExport = () => {
    exportFromJSON({
      data: rows,
      fileName:
        "recomendacion-paquetes-" +
        (currentFilters?.nombre || "preseleccion").replace(/\s+/g, "-") +
        "-" +
        new Date().toISOString().split("T")[0],
      exportType: exportFromJSON.types.csv,
    });
  };

  const handleJsonExport = () => {
    exportFromJSON({
      data: rows,
      fileName:
        "recomendacion-paquetes-" +
        (currentFilters?.nombre || "preseleccion").replace(/\s+/g, "-") +
        "-" +
        new Date().toISOString().split("T")[0],
      exportType: exportFromJSON.types.json,
    });
  };

  const handleExcelExport = async () => {
    try {
      await downloadExcelFromApi();
    } catch (e) {
      await swal({ title: "Error", text: e.message || "No se pudo descargar el archivo", icon: "error" });
    }
  };

  return (
    <>
      <div className="mb-4 d-flex align-items-center">
        <div className="admin-page-tilte">(</div>
        <LibraryBooksIcon />
        <div className="admin-page-tilte mr-2">)</div>
        <div className="admin-page-tilte">Recomendación de paquetes de renovación</div>
      </div>
      <Container fluid>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <RecomendacionFiltro onSubmit={handleGenerar} submitting={loading} />
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="content-white-box px-4 py-4">
            <div className="d-flex align-items-center">
              <MenuBookIcon />
              <div className="admin-main-title-dark-gray ml-2 mt-1">
                Preselección de libros
                {currentFilters?.nombre ? ` — ${currentFilters.nombre}` : ""}
              </div>
            </div>
            <div className="admin-muted-text-small mt-1 mb-4">
              Libros recomendados por categoría para renovación de paquetes.
            </div>

            {resumen && (
              <div className="admin-muted-text-small mb-3">
                Resumen: Más leídos del cliente ({resumen["Más leídos del cliente"] || 0}) · Más
                leídos global ({resumen["Más leídos global"] || 0}) · Novedades (
                {resumen["Novedades"] || 0})
              </div>
            )}

            {rows.length <= 0 || columns.length <= 0 ? (
              <>
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
                <Skeleton animation="wave" />
              </>
            ) : (
              <>
                <TableColumnDropdown columns={columns} changeColumnStatus={changeColumnStatus} />
                <br />
                <ButtonGroup size="small" variant="contained" className="my-3">
                  <CustomGreenButton
                    onClick={() => {
                      navigator.clipboard.writeText(JSON.stringify([...rows])).then(async () => {
                        await swal({ title: "Se ha copiado la tabla!", icon: "success" });
                      });
                    }}
                  >
                    Copy
                  </CustomGreenButton>
                  <CustomGreenButton onClick={handleCsvExport}>CSV</CustomGreenButton>
                  <CustomGreenButton onClick={handleJsonExport}>JSON</CustomGreenButton>
                  <CustomGreenButton onClick={handleExcelExport}>EXCEL</CustomGreenButton>
                </ButtonGroup>
                <MDBDataTableV5
                  small
                  responsive
                  searchTop
                  searchBottom={false}
                  barReverse
                  pagingTop
                  striped
                  bordered
                  data={{
                    columns: columns.filter((obj) => obj.isVisible),
                    rows: rows,
                  }}
                  noBottomColumns
                  order={["posicion", "asc"]}
                  entriesOptions={[5, 10, 20, 50]}
                  entriesLabel="Numero de filas"
                  searchLabel="Buscar"
                  paginationLabel={["Anterior", "Siguiente"]}
                  infoLabel={["Mostrando filas", "a", "de", "filas"]}
                  fullPagination
                />
              </>
            )}
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default RecomendacionPaquetes;
